
export default function Guarantees() {
  return (
    <section id="garanties" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 font-nunito">
            Votre artisan électricien
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-nunito">
            Artisan électricien, nous réalisons vos travaux d'électricité générale et de dépannage. 
            Intervention rapide sur coupure de courant totale ou partielle dans la région nantaise.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-stone-50 rounded-2xl">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-tools-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4 font-nunito">Artisan électricien</h3>
              <p className="text-gray-600 font-nunito">
                Particuliers & professionnels, région nantaise
              </p>
            </div>

            <div className="text-center p-8 bg-stone-50 rounded-2xl">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4 font-nunito">Dépannage rapide</h3>
              <p className="text-gray-600 font-nunito">
                Dépannage dans les plus brefs délais
              </p>
            </div>

            <div className="text-center p-8 bg-stone-50 rounded-2xl">
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-2xl text-red-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4 font-nunito">Assurance décennale</h3>
              <p className="text-gray-600 font-nunito">
                Tous les travaux sont couverts par l'assurance décennale professionnelle
              </p>
            </div>
          </div>

          <div className="mt-16 text-center bg-red-50 rounded-2xl p-12">
            <h3 className="text-3xl font-bold text-gray-800 mb-6 font-nunito">
              Plus de 30 ans d'expérience
            </h3>
            <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto font-nunito">
              Vous avez la garantie d'une installation conforme et d'un travail de qualité. 
              Devis clair, travail soigné, installation conforme.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+33656847324"
                className="inline-flex items-center bg-red-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer shadow-lg font-nunito"
              >
                <i className="ri-phone-line mr-2"></i>
                06 56 84 73 24
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
